import { Cluster } from '@cast/types';

import { NodeWithDependencies } from 'features/cluster/nodes/types';
import { useNodeStorageCurrentMetricsQuery } from 'hooks/queries/nodes/useNodeStorageCurrentMetricsQuery';

import { StorageCurrentUsage } from '../_components/StorageCurrentUsage';

type ManagedDiskAllCurrentUsageProps = {
  node?: NodeWithDependencies;
  cluster: Cluster;
  isCloudDisksEnabled?: boolean;
};

export const ManagedDiskAllCurrentUsage = ({
  node,
  cluster,
  isCloudDisksEnabled,
}: ManagedDiskAllCurrentUsageProps) => {
  const { currentAvg, isLoading, error, refetch } =
    useNodeStorageCurrentMetricsQuery({
      clusterId: cluster.id,
      nodeName: node?.name,
      storageType: 'managed-ephemeral',
    });

  return (
    <StorageCurrentUsage
      usedBytes={currentAvg?.usedBytes}
      totalBytes={currentAvg?.totalBytes}
      iops={currentAvg?.iops}
      provisionedIops={currentAvg?.provisionedIops}
      throughputBytes={currentAvg?.throughputBytes}
      provisionedThroughputBytes={currentAvg?.provisionedThroughputBytes}
      isLoading={isLoading}
      error={error}
      refetch={refetch}
      isCloudDisksEnabled={isCloudDisksEnabled}
    />
  );
};
